/* eslint-disable react-hooks/exhaustive-deps */
import { Stack } from '@chakra-ui/react'
import React from 'react'
import DataTables from '../../../../../components/Datatable';
import {getRangeAsync} from '../../../../../redux/bond/actions';
import moment from 'moment';

export const Pending = ({user_id=null}) => {
  

  const selectable = (state)=>(state.bond.multiplier.range.pending);

  const columns = (row)=>{
    return {
     nombre: row?.bond,
     nst : 'USDT '+row?.nst,
     credito : 'USDT '+row?.credits,
     total : 'USDT '+row?.total_bond,
     fecha : moment(row?.created_at || 'Y-m-d').format('YYYY-MM-D H:M'),
     fecha_de_solicitud : moment(row?.created_at || 'Y-m-d').format('YYYY-MM-D H:M'),
    }
  } 


  const dispatchable=(query)=>{

    if (user_id!= null) {
      return getRangeAsync({
        ...query,
        user_id,
        charged:0,
      });
    }

    return getRangeAsync({
      ...query,
        charged:0,
    });
  } 

  return (
    <Stack style={{ display: 'flex', flexDirection: 'row' }} bg={'white'}>
     <DataTables  
          columns={columns}
          dispatchable={dispatchable}
          selectable={selectable}
          title='Lista de bonos pendientes'
      />
    </Stack>  
  )
}
